import { IAddAddonForm } from "../Addon/addon.interface";
import { IPageInfo } from "../common.interface";
import { IAddon, IOrder } from "../Order/order.interface";

export type actionType = "instant_refund" | "pickup_and_verify";

export enum ReturnStatus {
  // Admin review phase
  PENDING_REVIEW = 'pending_review',
  APPROVED = 'approved',
  REJECTED = 'rejected',

  // Driver assigned for return pickup
  PICKUP_ASSIGNED = 'pickup_assigned',

  // Re-delivery attempt to customer
  RE_ROUTE_TO_CUSTOMER = 're_route_to_customer',
  RE_ARRIVED_AT_CUSTOMER = 're_arrived_at_customer',
  RETURN_COLLECTED = 'return_collected',

  // Return journey back to store
  RE_ROUTE_TO_STORE = 're_route_to_store',
  RE_ARRIVED_AT_STORE = 're_arrived_at_store',
  RETURN_DELIVERED = 'return_delivered',
}

export interface IReturnOrder {
  actionType: actionType,
  createdAt: string,
  customerNotes: string,
  deletedAt: string,
  driverId: string,
  id: string,
  storeId: string,
  order: IOrder,
  orderId: string,
  reason: string,
  refundAmount: string,
  refundMethod: string,
  rejectionReason: string,
  status: ReturnStatus,
  updatedAt: string,
  userId: string,
  media?: Array<{
    id: string;
    url: string;
    referenceType: string;
    referenceId: string;
    createdAt: string;
    updatedAt: string;
  }>;
  user?: {
    fullName: string;
    phone: string;
    media?: any[];
  };
  driver?: {
    fullName: string;
    email: string;
    phone: string;
    media?: any[];
  };
  returnItems?: Array<{
    id: string;
    returnRequestId: string;
    orderItemId: string;
    status: 'approved' | 'pending' | 'rejected';
    createdAt: string;
    updatedAt: string;
    orderItem: {
      id: string;
      orderId: string;
      productId: string;
      storeId: string;
      variantId: string | null;
      quantity: number;
      unitPrice: string;
      createdAt: string;
      updatedAt: string;
      discountedProductAmount?: string;
      store?: {
        id: string;
        userId: string;
        name: string;
        description: string;
        address: string;
        contact: string;
        status: string;
        latitude: string;
        longitude: string;
        createdAt: string;
        updatedAt: string;
      };
      product?: {
        name: string;
        media?: Array<{ url: string }>;
        category?: { id: string; name: string };
        subCategory?: { id: string; name: string };
      };
    };
    returnItemAddons?: IAddon[];
  }>;
}

export interface IReturnOrderlistResponse {
  data: {
    returnRequests: IReturnOrder[],
    pageInfo: IPageInfo
  }
}